import { render } from "./abilities.vue?vue&type=template&id=70a00e44"
import script from "./abilities.vue?vue&type=script&lang=js"
export * from "./abilities.vue?vue&type=script&lang=js"

import "./abilities.vue?vue&type=style&index=0&id=70a00e44&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__